var _path, _path2, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 93,
    viewBox: "0 0 125 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6711 92.1871L37.6689 72.9785H21.352L21.6711 92.1871Z",
    fill: "#98B9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.589066 37.0095C0.589066 47.2181 3.2441 55.9317 8.55426 63.1503C13.8643 70.3688 20.2742 73.9781 27.7839 73.9781H97.106C104.616 73.978 111.025 70.3688 116.336 63.1502C121.646 55.9317 124.301 47.2181 124.301 37.0095C124.301 26.801 121.646 18.0874 116.336 10.8688C111.025 3.65029 104.616 0.0410156 97.106 0.0410156L27.7839 0.0410276C20.2742 0.0410276 13.8643 3.6503 8.55426 10.8689C3.2441 18.0874 0.589066 26.801 0.589066 37.0095Z",
    fill: "#98B9F2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.79869,
    cy: 6.5233,
    rx: 4.79869,
    ry: 6.5233,
    transform: "matrix(-1 0 0 1 50.7129 30.4863)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.79869,
    cy: 6.5233,
    rx: 4.79869,
    ry: 6.5233,
    transform: "matrix(-1 0 0 1 67.2451 30.4863)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.79869,
    cy: 6.5233,
    rx: 4.79869,
    ry: 6.5233,
    transform: "matrix(-1 0 0 1 83.7744 30.4863)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleMobile);
export default __webpack_public_path__ + "static/media/bubble_mobile.ae73fa6bfcb63d752b45f55cbeb86f60.svg";
export { ForwardRef as ReactComponent };